import { useState, useEffect } from 'react';

const navItems = [
  { label: '홈', href: '#home' },
  { label: '서비스', href: '#services' },
  { label: '자격기준', href: '#eligibility' },
  { label: '진행절차', href: '#process' },
  { label: '상담신청', href: '#contact' },
  { label: '회사소개', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }} className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/cd8cec768b3109c0a4823a362c5d27f5/f18308a8382c34f4574bec8e73cc4409.png"
            alt="머니박스대부중개 로고"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap hover:text-[#03C75A] ${
                  scrolled ? 'text-gray-700' : 'text-gray-800'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:01066065909"
            className="flex items-center gap-1 text-sm font-semibold text-[#03C75A] whitespace-nowrap"
          >
            <i className="ri-phone-fill text-base"></i>
            010-6606-5909
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
            className="bg-[#03C75A] text-white text-sm font-semibold px-4 py-2 rounded-md whitespace-nowrap cursor-pointer hover:bg-[#00A843] transition-colors"
          >
            24시간 상담
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex items-center justify-center w-8 h-8 text-gray-700 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="block py-3 text-sm font-medium text-gray-700 border-b border-gray-50 hover:text-[#03C75A] cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a
            href="tel:01066065909"
            className="block mt-3 text-center bg-[#03C75A] text-white text-sm font-semibold py-3 rounded-md"
          >
            010-6606-5909 전화 상담
          </a>
        </div>
      )}
    </nav>
  );
}
